import React from 'react';
import { MILE } from 'utils/distanceTypes';
import { parseToNumber } from 'utils/helpers';
import { distanceOptionsSingular, distanceOptionsPlural } from './distanceOptions';
import {
  StyledCoreNumberInput,
  StyledCoreDropdown,
  InputWrapper,
  DistancePickerContainer,
  ReadOnlyContainer,
} from './DistancePicker.styled';

// type Props = {
//   /** Additional classes */
//   className: string,
//   /** Additional classes for read only mode. */
//   classNameReadOnly: string,
//   /** If distance picker is disabled. */
//   disabled: boolean,
//   /** The distance value. */
//   distance: number,
//   /** Special flag if picker is in query builder. */
//   inQueryBuilder: boolean,
//   /** If number input does not suppoert decimals. */
//   noDecimals: boolean,
//   /**
//    * Callback function when distance is changed.
//    *
//    * ```
//    * onChange(e, props) => {}
//    * ```
//    * @param { Object } e: The change event.
//    * @param { Object } props: Updated props containing new distance values { distance, unit }.
//    * @returns { void }
//    */
//   onChange: () => {},
//   /** The unit of the distance. */
//   unit: string,
// };

export default class DistancePicker extends React.Component {
  static defaultProps = {
    distance: 1,
    noDecimals: false,
    unit: MILE,
    disabled: false,
  };

  /**
   * getOptions
   * Gets the dropdown unit options based on if distance is singular or not.
   * @param { Number } distance: The distance value to determine options.
   * @returns { Array } List of dorpdown options.
   */
  getOptions = (distance) => {
    const isSingular = parseFloat(distance, 10) === 1;
    return isSingular ? distanceOptionsSingular : distanceOptionsPlural;
  };

  /**
   * handleChangeDistance
   * Callback function when distance is changed.
   * @param { Object } e: The change event.
   * @param { Object } updatedProps: The updated props containing the new distance value.
   * @returns { void }
   */
  handleChangeDistance = (e, { value }) => {
    const { onChange, unit } = this.props;
    onChange(e, { distance: parseToNumber(value), unit });
  };

  /**
   * handleChangeUnit
   * Callback function when unit is changed.
   * @param { Object } e: The change event.
   * @param { Object } updatedProps: The updated props containing the new unit value.
   * @returns { void }
   */
  handleChangeUnit = (e, { value }) => {
    const { onChange, distance } = this.props;
    onChange(e, { distance, unit: value });
  };

  render() {
    const { className, classNameReadOnly, disabled, distance, inQueryBuilder, noDecimals, unit } =
      this.props;
    const distanceLabel = `${distance}${unit}`;

    return (
      <>
        {inQueryBuilder && (
          <ReadOnlyContainer className={classNameReadOnly}>{distanceLabel}</ReadOnlyContainer>
        )}
        <DistancePickerContainer className={className}>
          <InputWrapper>
            <StyledCoreNumberInput
              data-test="collections-distance-input"
              allowDecimal={!noDecimals}
              allowNegative={false}
              fluid
              inline
              onChange={this.handleChangeDistance}
              prepend
              value={distance}
              disabled={disabled}
              disableIncrement={disabled}
              disableDecrement={disabled}
            />
            <StyledCoreDropdown
              data-test="collections-distance-unit"
              disabled={disabled}
              fluid
              onChange={this.handleChangeUnit}
              options={this.getOptions(distance)}
              value={unit}
            />
          </InputWrapper>
        </DistancePickerContainer>
      </>
    );
  }
}
